import React from 'react';
import {useIntl} from 'react-intl';
import {LiteEmptyPage} from './LiteEmptyPage';

export const LiteDatasetInfo = () => {
  const intl = useIntl();
  return (
    <LiteEmptyPage>
      <h5>{intl.formatMessage({id: 'studioLite.datasets.header'})}</h5>
      <p>{intl.formatMessage({id: 'studioLite.datasets.1'})}</p>
      <p>
        {intl.formatMessage(
          {id: 'studioLite.datasets.2'},
          {
            learnLink: (
              <a
                href="https://www.blaize.com/products/ai-studio/"
                target="_blank"
                rel="noreferrer"
              >
                here
              </a>
            ),
          }
        )}
      </p>
    </LiteEmptyPage>
  );
};
